import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'scenic-lead-form',
  name: '获客留资',
  icon: '表',
  group: '智慧景区',
  description: '收集游客姓名、手机号和意向。',
  defaultProps: {
    title: '咨询预订',
    submitButtonText: '提交',
    successText: '提交成功，我们将尽快与您联系'
  }
}
